import DocumentFormatPattern from '@/domain/models/document-format-pattern-model'
import { i18nTranslationHelper } from '@/i18n'

const t = {
  validations: i18nTranslationHelper.getTValidations
}

const OptionalDocumentFormatPattern: DocumentFormatPattern<RegExp> = {
  normalize: (value: string) => value?.trim(),
  mask: /^[\w|.-]{0,50}$/,
  prepareChar: str => str,
  placeholder: '',
  blocks: {},
  validate: (): boolean => true,
  isValid: (): boolean => true,
  rules: {
    minLength: 0,
    maxLength: {
      value: 50,
      message: t.validations('maxLength', { maxChars: '50' })
    }
  }
}
export default OptionalDocumentFormatPattern
